import { render, staticRenderFns } from "./summary-chart.vue?vue&type=template&id=008eff60&"
import script from "./summary-chart.ts?vue&type=script&lang=ts&"
export * from "./summary-chart.ts?vue&type=script&lang=ts&"
import style0 from "./summary-chart.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports